import Analytics from './service/analytics';
import Repository from './service/repository';

const repository = new Repository();
const analytics = new Analytics();

export { repository, analytics };
